export default __webpack_public_path__ + "static/media/boots_of_the_whispering_blade.26e056e7.jpg";